// 缓存 key 常量
export const LANG_CACHE_KEY = 'LANG_LIST'
export const CONFIG_LIST_CACHE_KEY = 'CONFIG_LIST'
export const API_BUFFER_DATA = 'API_BUFFER_DATA'
export const GAME_WITH_STATUS_LIST = 'GAME_WITH_STATUS_LIST'

// 配置项列表接口项
export interface ConstDataListItem {
  /** 创建时间 */
  createTime?: number
  /** 创建人 */
  creator?: string
  /** 修改时间 */
  updateTime?: number
  /** 修改人 */
  updater?: string
  /** 主键 ID */
  id?: number
  /** 分类 */
  category?: string
  /** 名称 */
  name?: string
  /** 配置键名 */
  configKey?: string
  /** 配置值 */
  value?: string
  /** 类型 */
  type?: number
  /** 是否可见 */
  visible?: boolean
  /** 备注 */
  remark?: string | null
}

// 支持的语言代码 - BCP 47标准格式
export type LangCode = 'zh-CN' | 'en-US' | 'vi-VN' | 'hi-IN' | 'ta-IN' | 'ms-MY' | 'pt-BR'

// 支持的 i18n 语言代码 (与LangCode保持一致)
export type I18nLocale = 'zh-CN' | 'en-US' | 'vi-VN' | 'hi-IN' | 'ta-IN' | 'ms-MY' | 'pt-BR'

// 语言代码映射类型
export type LangCodeMap = Record<LangCode, I18nLocale>

// 语言翻译项（数据库结构）
export interface LangDataItem {
  /** 主键 ID */
  id?: number
  /** 国家代码（如 zh/en/vi） */
  countryCode: string
  /** 文案识别码 */
  langKey: string
  /** 中文翻译 */
  langValueZh: string
  /** 英文翻译 */
  langValueEn: string
  /** 越南文翻译 */
  langValueVi: string
  /** 发布时间 */
  langReleaseTime: string
}

// 多语言资源结构 - 按语言分组的翻译内容
export type LangData = Record<LangCode, Record<string, string>>

// 语言信息接口
export interface LanguageInfo {
  code: LangCode
  i18nCode: I18nLocale
  name: string
  nativeName: string
  flag: string
}

// 主题项
export interface ThemeItem {
  /** 主题 ID */
  id: number
  /** 主题名称 */
  themeName: string
}

// 主题子项
export interface ThemeSubItem {
  /** 主题字段 key */
  themeKey: string
  /** 主题值 */
  themeValue: string
  /** 主题类型：1 颜色 | 2 图片 | 3 lottie 动画 */
  themeType?: number
}

// 通用资源类型：图标（可根据明/暗模式区分）
export type ThemeIcon = {
  light?: {
    /** 未选中图标 */
    unselected?: string
    /** 已选中图标 */
    selected?: string
  }
  dark?: {
    /** 未选中图标 */
    unselected?: string
    /** 已选中图标 */
    selected?: string
  }
}

export type GetSimpleDictDataListRes = {
  value?: string
  label?: string
}

// 版本配置
export type VersionConfig = {
  /** 主键 ID */
  id: number
  /** 版本号 */
  version: string
  /** 是否强制更新 */
  forceUpdate: boolean
  /** 更新描述 */
  description: string
}

// 游戏项接口
export interface GameItem {
  /** 游戏 ID */
  id: number
  /** 游戏名称 */
  name: string
  /** 游戏状态 */
  status: number
  /** 游戏类型 */
  type: string
  /** 游戏图标 */
  icon?: string
  /** 游戏描述 */
  description?: string
  /** 排序 */
  sort?: number
}

export type ApiFileListType = Array<{
  apiName: string
  memoryAddress: string
}>
